import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import HomeworkQuizModal from './HomeworkQuizModal';

interface Props {
  homeworkId: number;
  label?: string;
}

const HomeworkQuizButton: React.FC<Props> = ({ homeworkId, label }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="default" size="sm" iconName="HelpCircle" onClick={() => setOpen(true)}>
        {label || 'Quiz'}
      </Button>
      <HomeworkQuizModal open={open} homeworkId={homeworkId} onClose={() => setOpen(false)} />
    </>
  );
};

export default HomeworkQuizButton;
